import { cx } from '@linaria/core';
import { useRef } from 'react';
import { useElementSize } from '@utils/react';
import { usePageContext } from '../../../../context.js';
import { leftColumnSize, wrapper, scroller, table, thead, stickyContentWrapper, cellContent, stickyCellSpacer, cell, tableHeadingCell, stickyLeftColumnCell } from './_task.pool-coupon.style.js';
import { RowInput } from './input.row.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function SelectAnswersPoolCouponTask(props) {
  const pageContext = usePageContext();
  const tableRef = useRef(null);
  const leftmostHeadingRef = useRef(null);
  useElementSize(leftmostHeadingRef, {
    applyTo: tableRef,
    axis: "horisontal",
    varName: leftColumnSize.propName
  });
  return /*#__PURE__*/jsx("div", {
    className: wrapper,
    "data-page-context": pageContext,
    children: /*#__PURE__*/jsx("div", {
      className: scroller,
      children: /*#__PURE__*/jsxs("table", {
        ref: tableRef,
        className: table,
        children: [/*#__PURE__*/jsx("thead", {
          className: thead,
          children: /*#__PURE__*/jsxs("tr", {
            children: [/*#__PURE__*/jsxs("th", {
              ref: leftmostHeadingRef,
              className: cx(cell, tableHeadingCell, stickyLeftColumnCell),
              children: [/*#__PURE__*/jsx("div", {
                className: stickyContentWrapper,
                children: /*#__PURE__*/jsx("span", {
                  className: cellContent,
                  children: props.task.tableHeading
                })
              }), /*#__PURE__*/jsx("div", {
                className: cx(cellContent, stickyCellSpacer),
                children: props.task.tableHeading
              })]
            }), props.task.tableColumnHeadings.map((heading, index) => /*#__PURE__*/jsx("th", {
              className: cx(cell, tableHeadingCell),
              children: /*#__PURE__*/jsx("span", {
                className: cellContent,
                children: heading
              })
            }, index))]
          })
        }), /*#__PURE__*/jsx("tbody", {
          children: props.task.content.map(row => /*#__PURE__*/jsx(RowInput, {
            input: row,
            taskEntryKey: props.taskEntryKey,
            amountOfColumns: props.task.tableColumnHeadings.length
          }, row.id))
        })]
      })
    })
  });
}

export { SelectAnswersPoolCouponTask };
//# sourceMappingURL=_task.pool-coupon.js.map
